import { Profile } from 'common/types'
import { useUserApi } from 'hooks/use-user-api/useUserApi'
import { useUserProfileApi } from 'hooks/use-user-profile-api/useUserProfileApi'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useEffect, useState } from 'react'
import { QuestionAnswer } from 'common/types'
import { useHistory } from 'react-router-dom'
import { useLocalStorage } from 'hooks/use-local-storage/useLocalStorage'
import { usePartnerApi } from 'hooks/use-partner-api/usePartnerApi'

export const useProfile = (dontCall?: boolean) => {
  const { sendWelcomeEmail } = useUserApi()
  const { fetchProfile } = useUserProfileApi()
  const { sendPartnerWelcomeEmail } = usePartnerApi()

  const { backendUser, backendPartner, setPartner, setUser, forwardingUrl } = useAuth()
  const { getItem } = useLocalStorage()
  const [profile, setProfile] = useState<Profile>()
  const [showEditProfile, setShowEditProfile] = useState(false)
  const [showEditProfileMenu, setShowEditProfileMenu] = useState(getItem('profileEdited') === 'false' || false)
  const [questionAnswers, setQuestionAnswers] = useState<QuestionAnswer[]>()
  const [editPageNumber, setEditPageNumber] = useState<number>()
  const history = useHistory()
  const [showPreferences, setShowPreferences] = useState(false)

  useEffect(() => {
    const getData = async () => {
      if (backendUser) {
        const response = await fetchProfile(backendUser?.id)
        setProfile(response)
        setQuestionAnswers(backendUser.onboardingQuestions)
      }
    }
    if (!backendUser?.isOnBoarded) {
      history.push('/settings')
      return
    }
    if (!dontCall) getData()

  }, [])

  const onWelcome = async () => {
    if(backendUser?.partnerId){
      const partnerResponse = await sendPartnerWelcomeEmail(backendUser?.partnerId, backendUser?.id, {...backendPartner, welcomed: true}, backendPartner?.type)
      setPartner(partnerResponse)
    } else {
      const response = await sendWelcomeEmail(backendUser?.id, { ...backendUser, welcomed: true })
      setUser(response)
    }
  }

  return {
    profile,
    onWelcome,
    showEditProfile,
    setShowEditProfile,
    showEditProfileMenu,
    setShowEditProfileMenu,
    questionAnswers,
    setQuestionAnswers,
    editPageNumber,
    setEditPageNumber,
    showPreferences, 
    setShowPreferences
  } as const
}
